import Vue from 'vue';

export default [
    {
        pathId: 'ccats',
        component: 'course-categories',
        title: 'Course Categories',
        icon: 'fa-folder-tree',
        size: 'md',
        props: ['certificationId'],
        loading: true
    },
    {
        pathId: 'ccatn',
        component: 'new-course-category',
        title: 'New Category',
        icon: 'fa-plus',
        size: 'sm',
        props: ['certificationId', 'parentId']
    },
    {
        pathId: 'ccate',
        component: 'edit-course-category',
        title: 'Edit Category',
        icon: 'fa-pencil',
        size: 'sm',
        props: ['categoryId'],
        loading: true
    }
];

Vue.component('course-categories', () => import('@/cards/course_categories/CourseCategories'));
Vue.component('new-course-category', () => import('@/cards/course_categories/NewCategory'));
Vue.component('edit-course-category', () => import('@/cards/course_categories/EditCategory'));
